import CSVPreviewSection from '../CSVPreviewSection'

export default function TasksWithEstimatesEvACSVPreviewColumnStrategy() {}

TasksWithEstimatesEvACSVPreviewColumnStrategy.prototype = new CSVPreviewSection()

TasksWithEstimatesEvACSVPreviewColumnStrategy.prototype.getNumOfDataColumns = function() {
    return 0
}

TasksWithEstimatesEvACSVPreviewColumnStrategy.prototype.addDataColumns = function() {
    // do nothing
}
TasksWithEstimatesEvACSVPreviewColumnStrategy.prototype.addCellValues = function() {
    // do nothing
}





// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/eva/TasksWithEstimatesEvACSVPreviewColumnStrategy.js